// extracted by mini-css-extract-plugin
export default {"next-button":"FormNextBtn_next-button__jEs+V"};